import React, {createContext, useCallback, useContext, useEffect, useState} from 'react';

import {App} from './AppSingleton';
import {AppSignals} from "./AppSignals";
import {ViewMode} from "../models/view-types";

interface AppContextType {
	app: App,
}

const AppContext = createContext<AppContextType | null>(null);

export const useApp = () => {
	const context = useContext(AppContext);
	if (!context) {
		throw new Error('useApp must be used within AppProvider');
	}
	return context;
};



export const AppProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
	const [appInstance] = useState(() => App.getInstance());

	const contextValue: AppContextType = {
		app: appInstance,
	};

	return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
